const STORAGE_KEY = 'unada_discord_webhook_url';

/** One-time migration from older browser-only storage. */
export function getStoredDiscordWebhookUrl() {
  try {
    return (localStorage.getItem(STORAGE_KEY) || '').trim();
  } catch {
    return '';
  }
}

export function clearStoredDiscordWebhookUrl() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
